import { useState, useEffect } from 'react';
import { useAuthStore } from '../../store/authStore';

export function useOffline() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const [wasOffline, setWasOffline] = useState(false);
  const { token } = useAuthStore();
  const API = import.meta.env.VITE_API_URL || '';

  useEffect(() => {
    const handleOnline = () => {
      setIsOffline(false);
      setWasOffline(true);
      setTimeout(() => setWasOffline(false), 3000);
    };
    const handleOffline = () => {
      setIsOffline(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Ping check
    const int = setInterval(async () => {
      if (!navigator.onLine || !token) return;
      try {
        await fetch(`${API}/api/auth/me`, { headers: { Authorization: `Bearer ${token}` }});
        if (isOffline) handleOnline();
      } catch {
        handleOffline();
      }
    }, 60000);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
      clearInterval(int);
    };
  }, [isOffline, token, API]);

  return { isOffline, wasOffline };
}
